import { useDataLhId } from '@/composables/useDataLhId'
import type { DataLhIdModule } from '@/utils/data-lh-id/types'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      useLhId: (params: DataLhIdModule.DataLhIdParams) => useDataLhId(params).value
    }
  }
})
